import React from 'react';
import CatalogPage from './CatalogPage';

const BooksPageSimple = () => <CatalogPage forcedCategory="libro" title="Libros" />;

export default BooksPageSimple;
